<template>
  <div class="container" :class="!isMobile ? 'pc' : 'mb'">
    <sys-dialog
      v-show="dialogVisible"
      :bgi="dialogBgi"
      :show-button="true"
      :errorMsg="errorMsg"
      @close="dialogVisible = false"
    />
    <sys-loading :loading="loading" />
    <div class="header">
      <img class="logo" src="../assets/year/logo.png" />
      <div class="title"></div>
    </div>
    <div class="content">
      <div class="form-container">
        <div class="form">
          <div class="banner-group">
            <div
              class="login-banner banner"
              :class="!isRegisterTag ? 'red-tag' : 'gray-tag'"
              @click="isRegisterTag = false"
            >
              ĐĂNG NHẬP
            </div>
            <div
              class="register-banner banner"
              :class="isRegisterTag ? 'red-tag' : 'gray-tag'"
              @click="isRegisterTag = true"
            >
              ĐĂNG KÝ
            </div>
          </div>
          <div class="form-input">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="user"
              class="svg-inline--fa fa-user fa-w-14 "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
              ></path>
            </svg>
            <input
              autocomplete="off"
              v-model="form.username"
              placeholder="Tên đăng nhập"
              maxlength="20"
            />
          </div>
          <div class="form-input" v-show="isRegisterTag">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="mobile-alt"
              class="svg-inline--fa fa-mobile-alt fa-w-10 "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
              ></path>
            </svg>
            <input
              autocomplete="off"
              v-model="form.phone"
              placeholder="Số điện thoại"
              maxlength="10"
              oninput="value=value.replace(/^\D/, '')"
            />
          </div>
          <div class="form-input">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="key"
              class="svg-inline--fa fa-key fa-w-16 "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
              ></path>
            </svg>
            <input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="Mật khẩu"
            />
          </div>
          <div class="form-input" v-show="isRegisterTag">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="envelope"
              class="svg-inline--fa fa-envelope fa-w-16 "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
              ></path>
            </svg>
            <input
              v-model="form.email"
              autocomplete="off"
              placeholder="Email"
            />
          </div>
          <a
            v-show="!isRegisterTag"
            class="forget-pwd"
            href="https://www.888b.com"
            >Quên mật khẩu ?</a
          >
          <div class="action" v-show="!isRegisterTag" @click="submitAction(2)">
            ĐĂNG NHẬP
          </div>
          <v-captcha
            ref="vcaptcha1"
            :dialogVisible="dialogVisible"
            :showCheck="showCheck"
            @cb="handleConfirm"
            :vstyle="{ position: 'absolute', bottom: '-20px' }"
            :nativeButton="
              isMobile
                ? {
                    width: '150px',
                    height: '55px'
                  }
                : {
                    width: '220px',
                    height: '84px'
                  }
            "
          >
            <div class="action" v-show="isRegisterTag" @click="submitAction(1)">
              ĐĂNG KÝ
            </div>
          </v-captcha>
        </div>
      </div>
      <div v-if="!isMobile" class="slide-container">
        <div class="slide">
          <div class="slick-slider slider-c slick-initialized" dir="ltr">
            <sys-swiper :pagination="true" :swiper-images="swiperYearImg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SWIPER_YEAR_IMG,
  FORM_VALID_MESSAGE,
  DOMAIN_INVITE_CODE
} from "../utils/constant";
import { userRegister, userLogin, createCustomer } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import md5 from "js-md5";
import { captcha } from "@/mixins/captcha";

export default {
  name: "NewYear",
  mixins: [captcha],
  data() {
    return {
      isMobile: isMobile(),
      dialogVisible: false,
      loading: false,
      swiperYearImg: SWIPER_YEAR_IMG,
      dialogBgi: require("../assets/year/bgi-model.png"),
      isRegisterTag: true,
      errorMsg: {
        title: "",
        content: ""
      },
      form: {
        by: 1,
        username: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
  },
  methods: {
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
//@import "NewYear.less";
.container {
  height: 100vh;
  overflow-y: hidden;
  height: 100vh;
  font-family: UTMMabella;
  letter-spacing: 2px;
  display: flex;
  flex-direction: column;

  .header {
    height: 250px;
    align-items: center;
    justify-content: center;
    margin-bottom: -150px;
    margin-top: 50px;
    display: flex;
    flex-direction: column;

    .logo {
      height: 100px;
      width: auto;
      margin-bottom: 10px;
    }

    .title {
      background-image: url("../assets/year/title.png");
      width: 500px;
      height: 85px;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }

  .content {
    display: flex;
    flex: 1 1;

    .form-container {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 5vh;

      .form {
        background-image: url("../assets/year/bgi-form.png");
        background-size: 100% 100%;
        position: relative;
        padding: 60px 100px;
        height: fit-content;

        .banner-group {
          position: absolute;
          height: 60px;
          width: 100%;
          top: -30px;
          left: 0;
          display: flex;
          justify-content: center;

          .gray-tag {
            transform: scale(1);
            background-image: url("../assets/year/bgi-btn-i.png");
          }

          .red-tag {
            transform: scale(1.2);
            background-image: url("../assets/year/bgi-btn-a.png");
          }

          .banner {
            height: 100%;
            width: 200px;
            background-size: 100% 100%;
            margin: 0 10px;
            cursor: pointer;
            transition: all 0.25s ease;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 5px;
            font-weight: bolder;
            font-size: 28px;
            line-height: 100%;
            color: #fff;
            position: relative;
            border-top-left-radius: 9px;
            border-top-right-radius: 9px;
          }
        }

        .form-input {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 10px 20px;
          background-size: 100% 100%;
          transition: all 0.25s ease;
          border-radius: 20px;
          background-image: url("../assets/year/bgi-input.png");
          &:not(:last-child) {
            margin-bottom: 20px;
          }

          svg {
            font-size: 25px;
            margin-right: 10px;
            color: #fff;
          }
        }

        a.forget-pwd {
          color: #febf00;
          display: block;
          text-align: center;
          margin-bottom: 20px;
        }

        .action {
          position: absolute;
          width: 220px;
          left: calc(50% - 110px);
          display: flex;
          justify-content: center;
          bottom: -20px;
          padding: 25px 0;
          font-weight: 800;
          font-size: 24px;
          color: #fff;
          background-image: url("../assets/year/bgi-btn-reg.png");
          background-size: 100% 100%;
          cursor: pointer;
          border-radius: 20px;
          transition: all 0.25s ease;
          animation-name: btnMovie;
          animation-duration: 1s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
        }

        @keyframes btnMovie {
          0% {
            transform: scale(1);
          }
          25% {
            transform: scale(1.1);
          }
          50% {
            transform: scale(1);
          }
          75% {
            transform: scale(1.1);
          }
        }

        @-webkit-keyframes btnMovie {
          0% {
            transform: scale(1);
          }
          25% {
            transform: scale(1.1);
          }
          50% {
            transform: scale(1);
          }
          75% {
            transform: scale(1.1);
          }
        }
      }
    }

    .slide-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;

      .slide {
        height: 400px;
        width: 500px;

        .slider-c {
          height: 100%;
          width: 100%;
          position: relative;
          background-image: url("../assets/year/bgi-swiper.png");
          background-size: 100% 100%;
          padding: 30px 80px 0;
        }

        .slick-list,
        .slick-slider,
        .slick-track {
          position: relative;
          display: block;
        }

        .slick-slider {
          box-sizing: border-box;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          -webkit-touch-callout: none;
          -khtml-user-select: none;
          -ms-touch-action: pan-y;
          touch-action: pan-y;
          -webkit-tap-highlight-color: transparent;
        }
      }
    }
  }

  .svg-inline--fa.fa-w-14 {
    width: 0.875em;
  }

  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }

  svg:not(:root).svg-inline--fa {
    overflow: visible;
  }

  input {
    border: none;
    outline-width: 0;
    background-color: transparent;
    height: 40px;
    width: 300px;
    font-family: UTMAvo;
    font-weight: 500;
    font-size: 25px;
    color: #fff;
    padding: 1px 2px;
  }

  input::placeholder {
    color: #dddddd;
    font-width: 400;
  }
}

.container /deep/ .mask-layer .modal .close-btn {
  bottom: -25px;
  left: calc(50% - 60px);
  height: 50px;
  width: 120px;
  font-size: 24px;
}
@media only screen and (min-width: 767px) and (max-width: 1024px) {
  .container /deep/ .mask-layer .modal .close-btn {
    bottom: -30px;
    left: calc(50% - 75px);
    height: 60px;
    width: 150px;
  }
}

.container.pc {
  background-image: url("../assets/year/bgi.png");
  background-size: 100% 100%;
}
.container.mb {
  background-image: url("../assets/year/bgi-mobile.png");
  background-size: 100% 100%;
}

@media only screen and (min-width: 351px) and (max-width: 576px) {
  .container.mb {
    .header {
      height: 220px;
      margin-bottom: unset;
      margin-top: unset;

      .logo {
        height: 60px;
      }

      .title {
        width: 300px;
        height: 60px;
      }
    }

    .form-container {
      width: 100%;
      align-items: unset;

      .form {
        padding: 40px 70px;

        .banner-group {
          height: 35px;
          top: -17.5px;

          .banner {
            width: 110px;
            margin: 0 5.5px;
            font-size: 14px;
          }
        }

        .form-input {
          padding: 7px 12px;
          border-radius: 10px;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }

        .action {
          width: 150px;
          left: calc(50% - 75px);
          bottom: -15px;
          font-size: 18px;
          padding: 15px 0;
        }
      }
    }

    input {
      height: 20px;
      width: 160px;
      font-size: 16px;
    }

    svg {
      font-size: 18px !important;
    }
  }
}

@media only screen and (min-width: 767px) and (max-width: 1024px) {
  .container.mb {
    .header {
      height: 300px;

      .logo {
        height: 100px;
      }

      .title {
        height: 80px;
      }
    }

    .form-container {
      width: 100%;
      height: 100%;

      .form {
        padding: 70px 100px;

        .banner-group {
          height: 50px;
          top: -27px;

          .banner {
            width: 150px;
            margin: 0 7.5px;
            font-size: 18px;
          }
        }

        .form-input {
          padding: 10px 20px;
          border-radius: 15px;
          &:not(:last-child) {
            margin-bottom: 15px;
          }
        }

        .action-btn {
          position: absolute;
          width: 220px;
          left: calc(50% - 110px);
          display: flex;
          justify-content: center;
          bottom: -15px;
          padding: 25px 0;
          font-size: 24px;
        }

        .action {
          position: absolute;
          width: 220px;
          left: calc(50% - 110px);
          display: flex;
          justify-content: center;
          bottom: -15px;
          padding: 25px 0;
          font-size: 24px;
        }
      }
    }

    input {
      height: 35px;
      width: 250px;
      font-size: 22px;
    }

    svg {
      font-size: 22px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewYear.vue